<template>
    <div>
        <select
            :name="id"
            :id="id"
            :ref="id"
            :class="outterClass"
            v-model="locale"
            @change="changeLocale()"
        >
            <option
                v-for="(item, key) in items"
                :key="key"
                :value="key"
                :class="innerClass"
                :selected="checkSelected(key)"
                v-html="item"
            ></option>
        </select>
        <div
            class="spinner"
            v-if="show_loading"
            style="display:flex; justify-content: center; align-items: center; position:fixed; left: 0px; top: 0px; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7); cursor: wait;"
        >
            <h3 class="text-white" style="opacity: 0.7;">Please wait...</h3>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            locale: "",
            show_loading: false
        };
    },
    props: {
        id: {
            type: String,
            default: ""
        },
        items: {
            type: Object,
            default: () => {
                return null;
            }
        },
        selected: {
            type: String,
            default: ""
        },
        outterClasses: {
            type: String,
            default: ""
        },
        innerClasses: {
            type: String,
            default: ""
        },
        postUrl: {
            type: String,
            default: ""
        }
    },
    computed: {
        outterClass() {
            return this.outterClasses === ""
                ? "mx-3 text-uppercase"
                : this.outterClasses;
        },
        innerClass() {
            return this.innerClasses === ""
                ? "text-uppercase"
                : this.innerClasses;
        }
    },
    methods: {
        checkSelected(key) {
            return key === this.locale;
        },
        changeLocale() {
            let post_url = this.postUrl;
            console.log(this.locale);
            this.show_loading = true;
            axios
                .post(post_url, {
                    locale: this.locale
                })
                .then(response => {
                    this.show_loading = false;
                    window.location.reload();
                })
                .catch(error => {
                    console.error(error);
                    this.show_loading = false;
                });
        }
    },
    created() {
        if (this.selected != "") {
            this.locale = this.selected;
        }
    }
};
</script>

<style></style>
